export const FIELD_HOME_TEAM_SCORE = "home_team_score";
export const FIELD_AWAY_TEAM_SCORE = "away_team_score";
